function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient",
  x1: -35.52,
  y1: 14.65,
  x2: 413.22,
  y2: 436.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#55fdbd",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#55fdbd",
  stopOpacity: 0.51
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#55fdbd",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#55fdbd",
  stopOpacity: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#55fdbd",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-2",
  x1: -1505.57,
  y1: 274.12,
  x2: -1093.66,
  y2: 274.12,
  gradientTransform: "rotate(-151.54 -532.721 77.091)",
  xlinkHref: "#hero_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-3",
  x1: 256.09,
  y1: -22.28,
  x2: 352.24,
  y2: 112,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c184"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#23c184",
  stopOpacity: 0.83
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#23c184",
  stopOpacity: 0.55
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#23c184",
  stopOpacity: 0.37
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c184",
  stopOpacity: 0.3
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-4",
  x1: 258.07,
  y1: -91.56,
  x2: 464.82,
  y2: 197.19,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-5",
  x1: 250.34,
  y1: -10.36,
  x2: 332.96,
  y2: 105.04,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-6",
  x1: 255.72,
  y1: -58.99,
  x2: 476.62,
  y2: 235.2,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-7",
  x1: 245.57,
  y1: 4.34,
  x2: 331.17,
  y2: 123.89,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-8",
  x1: 230.31,
  y1: -76.44,
  x2: 434.14,
  y2: 208.24,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-9",
  x1: 242.67,
  y1: 12.83,
  x2: 325.29,
  y2: 128.23,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-10",
  x1: 341.06,
  y1: 3.67,
  x2: 370.62,
  y2: 3.67,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c184",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#23c184",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#23c184",
  stopOpacity: 0.07
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c184",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-11",
  x1: 323.03,
  y1: 14.33,
  x2: 347.51,
  y2: 14.33,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-12",
  x1: 323.09,
  y1: 37.57,
  x2: 345.27,
  y2: 37.57,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-13",
  x1: 236.82,
  x2: 236.82,
  y2: 193.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c184"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#23c184",
  stopOpacity: 0.94
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#23c184",
  stopOpacity: 0.54
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#23c184",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#23c184",
  stopOpacity: 0.07
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c184",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-14",
  x1: -16.74,
  y1: 72.06,
  x2: 147.03,
  y2: 300.79,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-15",
  x1: -31.26,
  y1: -57.8,
  x2: 268.27,
  y2: 360.53,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-16",
  x1: -23.74,
  y1: 96.42,
  x2: 119.14,
  y2: 295.97,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-17",
  x1: -55.8,
  y1: -43.44,
  x2: 243.84,
  y2: 375.04,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-18",
  x1: -26.61,
  y1: 89.36,
  x2: 139.2,
  y2: 320.94,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-19",
  x1: -31.72,
  y1: 129.01,
  x2: 95.13,
  y2: 306.17,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-20",
  x1: -84.01,
  y1: -29.33,
  x2: 215.61,
  y2: 389.13,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-21",
  x1: -53.87,
  y1: -50.03,
  x2: 245.16,
  y2: 367.6,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-22",
  x1: -40.07,
  y1: 162.44,
  x2: 90.38,
  y2: 344.64,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-23",
  x1: -103.66,
  y1: -6.76,
  x2: 195.68,
  y2: 411.31,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-24",
  x1: -75.51,
  y1: -26.83,
  x2: 223.86,
  y2: 391.27,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-25",
  x1: -46.99,
  y1: 149.55,
  x2: 110.04,
  y2: 368.86,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-26",
  x1: -96,
  y1: -15.05,
  x2: 203.25,
  y2: 402.88,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-27",
  x1: -52.29,
  y1: 147.93,
  x2: 116,
  y2: 382.97,
  xlinkHref: "#hero_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-28",
  x1: 141.12,
  y1: 159.49,
  x2: 174.73,
  y2: 159.49,
  xlinkHref: "#hero_svg__linear-gradient-10"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-29",
  x1: 120.83,
  y1: 176.04,
  x2: 159.8,
  y2: 176.04,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c184",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#23c184",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#23c184",
  stopOpacity: 0.07
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c184",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-30",
  x1: 141.12,
  y1: 209.13,
  x2: 159.98,
  y2: 209.13,
  xlinkHref: "#hero_svg__linear-gradient-29"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-31",
  x1: 141.12,
  y1: 256.44,
  x2: 168.74,
  y2: 256.44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c184",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#23c184",
  stopOpacity: 0.07
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c184",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-32",
  x1: 122.27,
  y1: 272.99,
  x2: 146.33,
  y2: 272.99,
  xlinkHref: "#hero_svg__linear-gradient-31"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-33",
  x1: 258.1,
  y1: 268.25,
  x2: 469.09,
  y2: 321.19,
  gradientTransform: "rotate(17.92 462.233 290.312)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#86dda5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#192f28"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__linear-gradient-34",
  x1: 350.06,
  y1: 125.12,
  x2: 479.92,
  y2: 284,
  gradientTransform: "rotate(6.21 443.39 218.615)",
  xlinkHref: "#hero_svg__linear-gradient-33"
}), /*#__PURE__*/React.createElement("style", null, ".hero_svg__cls-39{fill:none;stroke-miterlimit:10}.hero_svg__cls-35{fill:#192f28}.hero_svg__cls-36{fill:#fff}.hero_svg__cls-39{stroke:#fff;stroke-width:2.84px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 235.38,
  cy: 269.37,
  r: 204.48,
  opacity: 0.5,
  fill: "url(#hero_svg__linear-gradient)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 235.38,
  cy: 269.37,
  r: 204.48,
  stroke: "url(#hero_svg__linear-gradient-2)",
  strokeWidth: 2.96,
  fill: "none",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-3)",
  d: "M248.5 1.29h52.35v4.76H248.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-4)",
  d: "M311.48 1.29h29.57v4.76h-29.57z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-5)",
  d: "M248.5 11.95h39.02v4.76H248.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-6)",
  d: "M298.54 11.95h24.49v4.76h-24.49z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-7)",
  d: "M248.5 35.19h41.72v4.76H248.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-8)",
  d: "M300.85 35.19h22.18v4.76h-22.18z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-9)",
  d: "M248.5 45.85h39.02v4.76H248.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-10)",
  d: "M341.06 1.29h29.57v4.76h-29.57z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-11)",
  d: "M323.03 11.95h24.49v4.76h-24.49z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-12)",
  d: "M323.09 35.19h22.18v4.76h-22.18z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#hero_svg__linear-gradient-13)",
  strokeWidth: 2.96,
  fill: "none",
  strokeMiterlimit: 10,
  d: "M236.82 193.01V0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-14)",
  d: "M0 155.22h91.72v8.53H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-15)",
  d: "M107.52 155.22h33.61v8.53h-33.61z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-16)",
  d: "M0 171.77h66.52v8.53H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-17)",
  d: "M81.86 171.77h38.97v8.53H81.86z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-18)",
  d: "M0 188.32h94.6v8.53H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-19)",
  d: "M0 204.87h51.3v8.53H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-20)",
  d: "M67.67 204.87h38.11v8.53H67.67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-21)",
  d: "M122.27 204.87h18.85v8.53h-18.85z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-22)",
  d: "M0 252.18h54.47v8.53H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-23)",
  d: "M71.37 252.18h26.84v8.53H71.37z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-24)",
  d: "M113.51 252.18h27.61v8.53h-27.61z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-25)",
  d: "M0 268.73h82.79v8.53H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-26)",
  d: "M98.21 268.73h24.06v8.53H98.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-27)",
  d: "M0 285.28h98.21v8.53H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-28)",
  d: "M141.12 155.22h33.61v8.53h-33.61z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-29)",
  d: "M120.83 171.77h38.97v8.53h-38.97z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-30)",
  d: "M141.12 204.87h18.85v8.53h-18.85z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-31)",
  d: "M141.12 252.18h27.61v8.53h-27.61z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__linear-gradient-32)",
  d: "M122.27 268.73h24.06v8.53h-24.06z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M463 280.82c-32.48-4.93-23.86 37.79-23.86 37.79s-13.84-17.73-23.64-18.76-17.09 15.68-17.09 15.68l8.79-1.85-6.11 11.32 9.72-2.1-2.7 11.22 13.41-8.91s9.68 29.06 21.34 26.2S486 284.31 463 280.82z",
  fill: "url(#hero_svg__linear-gradient-33)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M508.55 239.88h-.08a1.77 1.77 0 00-1 .17 52.47 52.47 0 01-25.62 5.4c-2.76 0-4.95-.05-6.75.56a11.34 11.34 0 00-4.21 2.64c-4.59-7.6-12.89-12.31-24.7-14l-2.4-.34c-11.82-1.69-21.1.5-27.65 6.51a11.17 11.17 0 00-3.29-3.72c-1.55-1.09-3.66-1.69-6.32-2.43a52.49 52.49 0 01-23.08-12.38 1.81 1.81 0 00-.93-.43 1.76 1.76 0 00-1.95 2.23c.19.68.89 3.74 1.09 4.59.85 3.71 4.81 11.81 4.56 20.75 0 .86 0 1.86.05 2.89l5 1.48-4.45 2.47a21.36 21.36 0 004.63 10.08l6.34-2.14-3 5a19.87 19.87 0 0010 2.6 18 18 0 00-1.43 6 11 11 0 003.17 8.15c2.94 3.14 7.91 5.8 15.21 8.11a4.84 4.84 0 012.67 3.09c.37 2 3.81 3.5 10.78 4.61h.28c4 .54 7.08.61 9 .2a3.53 3.53 0 002.64-1.57 4.8 4.8 0 013.44-2.24c8.05-.18 13.75-1.44 17.44-3.84A10.71 10.71 0 00473 287v-.16a38.32 38.32 0 00.14-5.25 23 23 0 004 .78v-5.33l2.93 5.14.82-3 1.92 2.77a16.6 16.6 0 008.19-5.13l-5.11-5.82 7.42 2.88a23.91 23.91 0 003.25-6.68l-3.18-2.2h3.93l-4.63-3.12 5.27.81c2.69-7.41 7.79-13 9.46-16 .41-.73 1.95-3.42 2.34-4a1.72 1.72 0 00.29-.74 1.76 1.76 0 00-1.49-2.07z",
  fill: "url(#hero_svg__linear-gradient-34)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-35",
  d: "M488.63 253.12c-7.25 1.87-13.08 3.93-15 8.57s-1.19 11.62-.61 17.71c.07.68.13 1.37.17 2.05a27.55 27.55 0 004 .92v-5.33l2.93 5.14.82-3 1.92 2.77a16.6 16.6 0 008.19-5.13l-5.16-5.82 7.42 2.88a23.91 23.91 0 003.25-6.68l-3.18-2.2h3.93l-4.63-3.12 5.27.81c2.69-7.41 7.79-13 9.46-16 .41-.73 1.95-3.42 2.34-4-6.44 6.78-13.82 8.55-21.12 10.43zm-41.32-12.59c1-.52 5.27.64 5.27.64 1 .29 1.58 1.14 1 1.57a5.89 5.89 0 01-4.64.2c-2.06-.72-2.63-1.9-1.59-2.41zm-.91 4.02c2.41.47.74 2.72-.76 2.8s-3.63-1-3.2-1.87 2.71-1.17 4-.93zm-6.93-5.55c1.79.05 3.71 2.27 3.74 3.09 0 1-1.26 1.27-4.36 1.27s-5.66-1.85-5.54-2.69 4.37-1.75 6.16-1.67zM410 252.62c-.73-2.69-1.4-6.52-8.94-10.6l-.12-.07a46.75 46.75 0 01-8.9-5.29 50.81 50.81 0 01-11.46-12.58c.19.68.89 3.74 1.09 4.59.85 3.71 4.81 11.81 4.56 20.75 0 .86 0 1.86.05 2.89l5 1.48-4.45 2.47a21.36 21.36 0 004.63 10.08l6.34-2.14-3 5c2.3 1.43 4.83 2.45 10 2.59.26-.64.53-1.25.79-1.83 2.41-5.24 5.71-12.46 4.41-17.34zm51.31 25.91c-.64 2.69-2.74 4-7.83 3.19-.62-.09-1.26-.21-2-.36-5.44-1.18-7.72-2.32-13.68-3.21s-8.47-.47-14-1a18.51 18.51 0 01-2-.22c-5.09-.77-6.73-2.58-6.55-5.37-4.68 2.79-.06 8.51 3.74 11.18s8.91 4.54 16.38 5.88l1.64.25c7.53.89 13 .64 17.39-.8 4.34-1.41 10.5-5.52 6.84-9.57z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-36",
  d: "M416.59 279.23c-1.1-1.25-2.74-3.42-2.14-5.22a.12.12 0 01.23 0 6.14 6.14 0 003.82 3.18.13.13 0 01.05.21l-1.78 1.83a.13.13 0 01-.18 0zm2.76 2.54a17.55 17.55 0 01-1.86-1.59.19.19 0 010-.26l1.92-2a.12.12 0 01.21.09v3.61c0 .2-.14.27-.3.15zm1.29.23v-3.82a.37.37 0 01.44-.37l.68.11c.6.09 1.29.19 2 .23h.16a.37.37 0 01.23.63l-3.32 3.28a.12.12 0 01-.21-.08zm5.99 3.43a30.56 30.56 0 01-4.73-2.06.5.5 0 01-.11-.79c1-1 3.27-3.24 3.89-3.87a.13.13 0 01.21.06l1.38 6.08a.49.49 0 01-.64.58zm1.77.1L427 279a.5.5 0 01.5-.6l2 .06c1.17 0 2.32.07 3.58.15a.37.37 0 01.28.59l-4.71 6.36a.12.12 0 01-.22 0zm6.34 1.99c-1.66-.32-3.21-.66-4.65-1a.49.49 0 01-.27-.77l4.05-5.55a.13.13 0 01.22 0l1.23 6.73a.5.5 0 01-.58.58zm1.86-.3a.12.12 0 01-.23 0l-1.37-7.8a.49.49 0 01.55-.58c.68.07 1.41.17 2.2.29s1.52.24 2.2.37a.49.49 0 01.35.71l-3.65 7zm6.18 1.17c-1.49-.06-3.07-.19-4.75-.37a.5.5 0 01-.39-.73l3.16-6.07a.13.13 0 01.23 0l2.24 6.49a.5.5 0 01-.49.66zm1.67-.39l-2.63-7.47a.38.38 0 01.44-.49c1.23.3 2.34.61 3.47.92l2.09.57a.38.38 0 01.23.55l-3.38 5.92a.12.12 0 01-.22 0zm7.07-.17a31.37 31.37 0 01-5.12.58.5.5 0 01-.45-.75l3.11-5.4a.13.13 0 01.22 0c.41.78 1.92 3.62 2.58 4.85a.49.49 0 01-.34.72zm2.75-4.56l-1.15 3.64a.13.13 0 01-.23 0l-2.2-4.11a.37.37 0 01.41-.54h.16a18.93 18.93 0 002 .38l.68.09a.37.37 0 01.31.48zm2.41 2.81a19.32 19.32 0 01-2.25 1c-.19.07-.3 0-.24-.23l1.09-3.44a.12.12 0 01.23 0l1.25 2.47a.19.19 0 01-.08.25zm2.01-1.19c-.26.19-.54.37-.83.55a.12.12 0 01-.18-.05l-1.16-2.28a.12.12 0 01.1-.18 7.81 7.81 0 002.85-.6 4.58 4.58 0 001.74-1.32.12.12 0 01.22.08 2.27 2.27 0 01-.08.63 6.39 6.39 0 01-2.66 3.17z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-35",
  d: "M416 254.47c4 .48 8.39 5.77 15.58 9.94 2.63 1.52 5.51 2.85 5.92 3s-2.76-.07-4.61-.14a9 9 0 01-8.82 3.23c-5.35-.81-7.42-4.52-7.53-8.07a9.83 9.83 0 01.29-2.91s2.4 0 7.24 1.93c-2.88-2-5.31-3.58-7.61-4a12 12 0 00-4.14 0s1.24-3.3 3.68-3zM466 265c-2.31-.26-5.12.5-8.44 1.58 5.18-.38 7.48.3 7.48.3a10.48 10.48 0 01-.59 2.87c-1.14 3.35-4.23 6.29-9.58 5.48a9.08 9.08 0 01-7.47-5.69c-1.78-.48-4.91-1.16-4.45-1.22s3.6-.49 6.56-1.16c8.13-1.86 13.81-5.63 17.82-4.9 2.42.44 2.59 3.94 2.59 3.94A11.94 11.94 0 00466 265z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M457.56 266.62c5.16-.39 7.46.29 7.46.29a10.48 10.48 0 01-.59 2.87c-1.14 3.36-4.22 6.29-9.56 5.49a9 9 0 01-7.45-5.69 55.39 55.39 0 0010.14-3zm-24.68.72a9 9 0 01-8.8 3.23c-5.34-.8-7.41-4.52-7.51-8.06a10.61 10.61 0 01.28-2.92s2.4 0 7.22 1.93a54.65 54.65 0 008.81 5.82z",
  fill: "#3fb681"
}), /*#__PURE__*/React.createElement("path", {
  d: "M429.51 268c.5-1.48-7.47-4.77-7.47-4.77-2.48-1.37-2.56.35-2.2 1.27s1.41 4.16 3.9 4.91 5.43-.41 5.77-1.41zm31.49 2.73c-.57.8-2.59 3.38-5.18 3.54s-5-1.5-5.09-3 8.54-2.36 8.54-2.36c1.2-.21 3.18-.2 1.73 1.82z",
  fill: "#7bc7a7"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-36",
  d: "M426.69 265.57s2.59 1.07 2.47 2.28-3.73-2-4.69-2.56.07-.85 2.22.28zm27.39 4.18s-2.78.26-3 1.45 4.15-.79 5.23-1.06.19-.84-2.2-.39z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-39",
  cx: 638.47,
  cy: 439.05,
  r: 25.6
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-39",
  cx: 426.06,
  cy: 344.66,
  r: 31.03
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-39",
  cx: 601.49,
  cy: 129.18,
  r: 23.27
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-39",
  d: "M454.02 358.17l161.97 68.65M447.62 323.3l134.96-180.92m23.18 10.04l39.14 261.84m-243.18-88.74l-71.41-48.22"
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-39",
  cx: 317.86,
  cy: 268.51,
  r: 15.51
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-39",
  cx: 684.57,
  cy: 281.68,
  r: 15.51
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-36",
  cx: 342.85,
  cy: 201.66,
  r: 7.76
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__cls-36",
  cx: 255.8,
  cy: 301.62,
  r: 7.76
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__cls-39",
  d: "M681.13 296.81L644.9 414.26m-39.14-261.84l72.48 115.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.16 279.42l-51.36 22.2m67.49-47.64l17.93-47.96",
  strokeWidth: 3.19,
  strokeDasharray: "7.97 4.78",
  stroke: "#fff",
  fill: "none",
  strokeMiterlimit: 10
})));

function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 701.51 475.37"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/hero.0a9eef1e.svg";
export { SvgHero as ReactComponent };